




















import { Component, Prop, Vue } from 'vue-property-decorator';
import DialogBox from '@/components/dialog-box/DialogBox.vue';
import { Customer } from '@/model/Customer';
import formatPhone from '@/filters/PhoneFormatter';

@Component({
  components: { DialogBox },
  filters: { formatPhone }
})
export default class CustomerDialog extends Vue {
  @Prop({ default: false }) isDialogOpen: boolean;
  @Prop({ default: null }) customer: Customer;

  close() {
    this.$emit('close');
  }

  get firstName(): string {
    return this.customer?.firstName ?? '';
  }

  get lastName(): string {
    return this.customer?.lastName ?? '';
  }

  get phone(): string {
    return this.customer?.phone ?? '';
  }

  get email(): string {
    return this.customer?.email ?? '';
  }
}
